import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Center, Flex, Stack } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { AUTH_LINKS } from '@/modules/Auth/AUTH_LINKS.ts';
import SwiperCustom from '@/common/components/base/swiper/SwiperCustom.tsx';
import Button from '@/common/components/base/button/Button.tsx';
import { onboardingImageSliderData } from '@/modules/Auth/data/onBoardingImageData.ts';
import type { Swiper as SwiperType } from 'swiper';
const OnBoarding = () => {
  const [swiperIndex, setSwiperIndex] = useState(0);
  const navigate = useNavigate();
  const handleSwiperIndex = (index: number) => {
    index === 3 ? navigate(AUTH_LINKS.selectMode) : setSwiperIndex(index);
  };
  const swiperRef = useRef<SwiperType | null>(null);
  return (
    <Stack
      height="95dvh"
      maxWidth="maxContainer"
      mx="auto"
      py="20px"
      justifyContent="space-between"
    >
      <Flex justifyContent="end" width="90%" marginTop="1rem">
        <Typography
          textStyle="h2"
          color="black-3"
          onClick={() => navigate(AUTH_LINKS.selectMode)}
        >
          رد کردن
        </Typography>
      </Flex>
      <Center>
        <SwiperCustom
          imageSliderData={onboardingImageSliderData}
          handleSwiperIndex={handleSwiperIndex}
          onSwiperInit={(swiper) => {
            swiperRef.current = swiper;
          }}
        />
      </Center>
      <Flex width="90%" mx="auto" justifyContent="space-between">
        <Typography
          width="60px"
          textStyle="h2"
          color="black-3"
          id="prev"
          onClick={() => {
            swiperRef.current?.slidePrev();
          }}
        >
          {swiperIndex && swiperIndex !== onboardingImageSliderData.length - 1
            ? 'قبلی'
            : ''}
        </Typography>
        <Box width="auto!" id="containerForBullets"></Box>
        <Button
          borderRadius="16px"
          width="62px"
          color="success"
          size="small"
          onClick={() => {
            if (swiperIndex === onboardingImageSliderData.length - 1) {
              navigate(AUTH_LINKS.selectMode);
            } else {
              swiperRef.current?.slideNext();
            }
          }}
        >
          {swiperIndex === onboardingImageSliderData.length - 1
            ? 'شروع'
            : 'بعدی'}
        </Button>
      </Flex>
    </Stack>
  );
};

export default OnBoarding;
